;
define("product_details_options_selector.tpl", function(){});

